import { render } from "./WhiteLabelTheme.vue?vue&type=template&id=31cd0b5d"
import script from "./WhiteLabelTheme.vue?vue&type=script&lang=js"
export * from "./WhiteLabelTheme.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__